// React
import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
// Microsoft
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import * as microsoftTeams from '@microsoft/teams-js';
// Styling
import { Warning } from '@phosphor-icons/react';
import { TrialAlertContainer, TrialAlertContent } from './styles';
import { monetization } from '@microsoft/teams-js';
import { useTranslation } from 'react-i18next';

export function TrialAlert() {
  const appInsights = useAppInsightsContext();
  microsoftTeams.app.initialize();

  const { t } = useTranslation('alerts');

  const openPurchaseExperience = () => {
    if (process.env.REACT_APP_APP_INSIGHTS !== '') {
      appInsights.trackEvent({ name: 'Upgrade from banner clicked' });
      if (monetization.isSupported()) {
        monetization
          .openPurchaseExperience()
          .catch(() =>
            window.open(encodeURI('https://appsource.microsoft.com/en-us/product/web-apps/bitfractal1649005178126.dd1d8735-7a73-4914-929a-4f9fe0be6b75?tab=PlansAndPrice'))
          );
      } else {
        window.open(encodeURI('https://appsource.microsoft.com/en-us/product/web-apps/bitfractal1649005178126.dd1d8735-7a73-4914-929a-4f9fe0be6b75?tab=PlansAndPrice'));
      }
    }
  };

  return (
    <TrialAlertContainer>
      <BrowserView>
        <TrialAlertContent>
          <Warning size={32} weight="duotone" />
          <div className="text">
            <h1>{t('TRIAL_ALERT_TITLE')}</h1>
            <h2>{t('TRIAL_ALERT_SUBTITLE')}</h2>
          </div>
          <button id="upgradeButton" onClick={() => openPurchaseExperience()}>
            {t('TRIAL_ALERT_BUTTON')}
          </button>
        </TrialAlertContent>
      </BrowserView>
      <MobileView>
        <TrialAlertContent>
          <Warning size={32} weight="duotone" />
          <div className="text">
            <h1>{t('TRIAL_ALERT_TITLE')}</h1>
          </div>
        </TrialAlertContent>
      </MobileView>
    </TrialAlertContainer>
  );
}
